module.exports = __webpack_public_path__ + "img/hobbiton-3018-04-12.57ed8c91.jpg";